import React from "react";
import { TspCard } from "../../../components/primitives";

// Only the newest photos the API returned — never placeholder images.
export default function RecentActivitiesStrip({ items }) {
  const displayItems = items || [];

  return (
    <TspCard title="Recent Activities" className="tsp-recent-activities-card">
      {displayItems.length === 0 && <p className="tsp-muted-text">No photos uploaded yet.</p>}
      <div className="tsp-recent-activities-strip">
        {displayItems.map((item) => (
          <div key={item.id} className="tsp-recent-activity-thumb">
            <img src={item.image} alt={item.caption || "Recent TSP activity"} loading="lazy" />
          </div>
        ))}
      </div>
    </TspCard>
  );
}
